import type { FunctionComponent } from 'react';
import React from 'react';

import { NEW, PRODUCT_OUT_OF_STOCK, PRODUCT_UNAVAILABLE } from './constants/copy';
import * as styles from './styles';

export type PrimaryLabelProps = {
  className?: string;
  hasStock: boolean;
  isNew: boolean;
  salePercentage?: number;
  unavailable?: boolean;
};

export const PRIMARY_LABEL_UNAVAILABLE__P = 'PRIMARY_LABEL_UNAVAILABLE__P';
export const PRIMARY_LABEL_OUT_OF_STOCK__P = 'PRIMARY_LABEL_OUT_OF_STOCK__P';
export const PRIMARY_LABEL_ON_SALE__P = 'PRIMARY_LABEL_ON_SALE__P';
export const PRIMARY_LABEL_IS_NEW__P = 'PRIMARY_LABEL_IS_NEW__P';

export const PrimaryLabel: FunctionComponent<PrimaryLabelProps> = ({
  className,
  hasStock,
  isNew,
  salePercentage = 0,
  unavailable = false,
}: PrimaryLabelProps) => {
  if (unavailable) {
    return (
      <p
        className={className}
        css={[styles.primaryLabel, styles.unavailableLabel]}
        data-testid={PRIMARY_LABEL_UNAVAILABLE__P}
      >
        {PRODUCT_UNAVAILABLE}
      </p>
    );
  }
  if (!hasStock) {
    return (
      <p
        className={className}
        css={[styles.primaryLabel, styles.outOfStockLabel]}
        data-testid={PRIMARY_LABEL_OUT_OF_STOCK__P}
      >
        {PRODUCT_OUT_OF_STOCK}
      </p>
    );
  } else if (salePercentage > 0) {
    return (
      <p
        className={className}
        css={[styles.primaryLabel, styles.saleLabel]}
        data-testid={PRIMARY_LABEL_ON_SALE__P}
      >
        {salePercentage}% off
      </p>
    );
  } else if (isNew) {
    return (
      <p
        className={className}
        css={[styles.primaryLabel, styles.newLabel]}
        data-testid={PRIMARY_LABEL_IS_NEW__P}
      >
        {NEW}
      </p>
    );
  }
  return <></>;
};
